import React from 'react';
import {PREVIOUS_SEARCH_MESSAGE} from './store-products-status';

type ProductListStatusProps = {
    loading: boolean;
    hasLoadedSuccessfully: boolean;
    errorMessage: string;
    hasProducts: boolean;
    onRetry: () => void;
};

export const ProductListStatus: React.FC<ProductListStatusProps> = ({loading, hasLoadedSuccessfully, errorMessage, hasProducts, onRetry}) => {
    const showFirstLoad = !hasLoadedSuccessfully && !errorMessage;
    const showUpdating = loading && hasLoadedSuccessfully;
    const showError = !loading && !!errorMessage;
    const showPreviousSearch = showError && hasProducts && hasLoadedSuccessfully;

    if (!showFirstLoad && !showUpdating && !showError) {
        return null;
    }

    return (
        <div className={showUpdating ? 'product-list-status is-overlay' : 'product-list-status'}>
            {showFirstLoad && (
                <h2
                    className="text-center w-100"
                    aria-hidden="true"
                >
                    Loading products…
                </h2>
            )}
            {showUpdating && (
                <>
                    <i
                        className="fas fa-circle-notch fa-spin fast-spin product-list-spinner"
                        aria-hidden={true}
                    />
                    <h2
                        className="text-center w-100"
                        aria-hidden="true"
                    >
                        Updating products…
                    </h2>
                </>
            )}
            {showError && (
                <h2
                    className="text-center w-100"
                    aria-hidden="true"
                >
                    {errorMessage}
                </h2>
            )}
            {showPreviousSearch && (
                <p
                    className="product-list-previous"
                    aria-hidden="true"
                >
                    {PREVIOUS_SEARCH_MESSAGE}
                </p>
            )}
            {showError && (
                <button
                    type="button"
                    className="product-list-retry"
                    onClick={onRetry}
                >
                    Retry
                </button>
            )}
        </div>
    );
};
